module.exports = __webpack_public_path__ + "static/media/video_web_snappler_marzo_2021.23543bb4.mp4";